import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const PerDiem: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <NumberField
    name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.PerDiem}`}
    label={'Per Diem'}
    placeholder={'0.00'}
    data-test-id={'fee-detail-per-diem'}
    mode={'currency'}
    readOnly={readOnly}
  />
);
